module.exports = __webpack_public_path__ + "static/media/Stage.7ee35bda.JPG";